import React, { useEffect, useState } from "react";
import "./SignIn.css";
import { useNavigate } from "react-router-dom";
import logoImg from "../../assets/images/State-Distributor/logo.png";
// import logoImg from "../../assets/images/signinLogo.png";
import { useFormik } from "formik";
import { axiosInstance } from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import * as yup from "yup";

let siginSchema = yup.object({
  email: yup.string().required("Email is required"),
  password: yup.string().required("Password is required"),
});

export const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: siginSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.post("/login", values);
        if (response.data.status === "success" || response.status === 200) {
          toast.success(response.data.message || "Signin Successfull");
          const user_type = response.data.data.user_type;
          sessionStorage.setItem("token", response.data.data.token);
          sessionStorage.setItem("user_type", user_type);
          resetForm();
          setTimeout(() => {
            if (user_type === "DISTRIBUTOR") {
              navigate("/state-dashboard");
            } else {
              navigate("/sub-dashboard");
            }
          }, 3000);
        }
      } catch (error) {
        toast.error("Failed to sigin");
        console.log("Failed to signin");
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="signinContainer">
        <div className="signinSubContainer">
          <form onSubmit={formik.handleSubmit}>
            <div className="signLogo">
              <img src={logoImg} />
            </div>
            <div className="signTitle">Sign In to Your Account</div>
            <div className="signDesc">
              Access your dashboard and manage your business seamlessly.
            </div>
            <div className="signInput">
              <label>Email</label>
              <div>
                <input
                  type="email"
                  placeholder="Enter Email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {formik.errors.email && formik.touched.email && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {formik.errors.email}
                  </div>
                )}
              </div>
            </div>
            <div className="signInput">
              <label>Password</label>
              <div>
                <input
                  type="password"
                  placeholder="Enter Password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                {formik.errors.password && formik.touched.password && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {formik.errors.password}
                  </div>
                )}
              </div>
            </div>
            {/* <div className="d-flex justify-content-between">
              <div>
                <input type="checkbox" />
                <label className="rememberText">Remember me</label>
              </div>
              <div
                className="forgotText"
                onClick={() => {
                  sessionStorage.setItem("level", "sub");
                  sessionStorage.setItem("token", "sub");
                  navigate("/sub-dashboard");
                }}
              >
                Forgot password?
              </div>
            </div> */}
            <div className="btnSignin">
              <button
                type="submit"
                // onClick={() => {
                //   sessionStorage.setItem("level", "state");
                //   sessionStorage.setItem("token", "state");
                //   navigate("/state-dashboard");
                // }}
              >
                Sign In
              </button>
            </div>
            <div className="dontText">
              Don’t have an account ?{" "}
              <span style={{ color: "var(--color-theme)" }}>
                Contact Admin to Register
              </span>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
